import { Skeleton } from "antd";
import React, { ReactNode } from "react";
import { useInView } from "react-intersection-observer";
import "./LazyLoading.scss";

const LazyLoading: React.FC<any> = ({ children }: { children: ReactNode }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
    rootMargin: "-50px 0px"
  });

  return (
    <div className="LazyLoading" ref={ref}>
      {inView ? children : <Skeleton active />}
    </div>
  );
};

export default LazyLoading;
